/**
 * Datos del selector de emoji (`SelectorEmoji`): secciones útiles para las
 * finanzas de casa y, para el buscador, las palabras en español de cada
 * emoji (mapa palabra → emoji). Solo emojis Unicode estándar.
 */

export type IdSeccionEmoji =
  | 'casa'
  | 'comida'
  | 'transporte'
  | 'ocio'
  | 'salud'
  | 'ninos'
  | 'mascotas'
  | 'dinero'
  | 'facturas'
  | 'compras'
  | 'viajes'
  | 'otros';

/** `[emoji, palabras separadas por espacios]`. */
export type EntradaEmoji = readonly [string, string];

export type SeccionEmoji = {
  id: IdSeccionEmoji;
  emojis: readonly EntradaEmoji[];
};

export const SECCIONES_EMOJI: readonly SeccionEmoji[] = [
  {
    id: 'casa',
    emojis: [
      ['🏠', 'casa hogar vivienda hipoteca'],
      ['🏡', 'casa jardin chalet'],
      ['🏢', 'piso edificio comunidad'],
      ['🔑', 'llave alquiler'],
      ['🛋️', 'sofa muebles salon'],
      ['🛏️', 'cama dormitorio'],
      ['🧹', 'limpieza escoba'],
      ['🧺', 'colada lavanderia ropa'],
      ['🧽', 'limpieza esponja'],
      ['🧴', 'droguería limpieza'],
      ['🔧', 'reparacion arreglos'],
      ['🛠️', 'reformas herramientas bricolaje'],
      ['🪴', 'plantas jardin'],
      ['🌿', 'jardin plantas'],
      ['🚿', 'ducha baño'],
      ['🪑', 'muebles silla'],
      ['🏘️', 'comunidad vecinos'],
      ['🧯', 'seguro hogar'],
    ],
  },
  {
    id: 'comida',
    emojis: [
      ['🛒', 'supermercado compra carro'],
      ['🍎', 'fruta manzana fruteria'],
      ['🥦', 'verdura brocoli'],
      ['🥖', 'pan panaderia'],
      ['🥩', 'carne carniceria'],
      ['🐟', 'pescado pescaderia'],
      ['🧀', 'queso'],
      ['🥛', 'leche'],
      ['🍳', 'cocina desayuno'],
      ['🍽️', 'restaurante comer fuera'],
      ['🍕', 'pizza comida rapida'],
      ['🍔', 'hamburguesa comida rapida'],
      ['🥡', 'comida a domicilio para llevar'],
      ['🍣', 'sushi restaurante'],
      ['☕', 'cafe cafeteria'],
      ['🍺', 'cerveza bar'],
      ['🍷', 'vino'],
      ['🥐', 'desayuno cruasan'],
      ['🍰', 'tarta pasteleria postre'],
      ['🍫', 'chocolate dulces caprichos'],
    ],
  },
  {
    id: 'transporte',
    emojis: [
      ['🚗', 'coche auto'],
      ['⛽', 'gasolina combustible gasolinera'],
      ['🔌', 'carga electrico enchufe'],
      ['🅿️', 'aparcamiento parking'],
      ['🚌', 'autobus bus'],
      ['🚇', 'metro'],
      ['🚆', 'tren cercanias'],
      ['🚕', 'taxi'],
      ['🚲', 'bici bicicleta'],
      ['🛴', 'patinete'],
      ['🏍️', 'moto'],
      ['🛞', 'ruedas neumaticos'],
      ['🔩', 'taller mecanico'],
      ['🚙', 'coche todoterreno'],
      ['🛣️', 'peaje autopista'],
      ['🎫', 'abono billete transporte'],
    ],
  },
  {
    id: 'ocio',
    emojis: [
      ['🎬', 'cine pelicula'],
      ['🎭', 'teatro espectaculo'],
      ['🎵', 'musica'],
      ['🎤', 'concierto karaoke'],
      ['🎮', 'videojuegos consola'],
      ['📺', 'television series streaming'],
      ['📚', 'libros lectura'],
      ['🎨', 'arte pintura manualidades'],
      ['⚽', 'futbol deporte'],
      ['🏋️', 'gimnasio gym deporte'],
      ['🎾', 'tenis padel deporte'],
      ['🏊', 'piscina natacion'],
      ['🎲', 'juegos de mesa'],
      ['🎉', 'fiesta celebracion'],
      ['🍻', 'copas salir amigos'],
      ['📷', 'fotografia camara'],
      ['🎸', 'guitarra musica'],
      ['🧩', 'aficiones hobbies'],
    ],
  },
  {
    id: 'salud',
    emojis: [
      ['💊', 'farmacia medicinas pastillas'],
      ['🏥', 'hospital medico'],
      ['🩺', 'medico consulta'],
      ['🦷', 'dentista dientes'],
      ['👓', 'gafas optica'],
      ['🧠', 'psicologo salud mental'],
      ['💉', 'vacuna analisis'],
      ['🩹', 'botiquin'],
      ['💆', 'masaje fisio fisioterapia'],
      ['💇', 'peluqueria'],
      ['💅', 'estetica manicura'],
      ['🧘', 'yoga bienestar'],
      ['🧴', 'cuidado personal cosmetica'],
      ['🪥', 'higiene'],
      ['❤️', 'salud corazon'],
    ],
  },
  {
    id: 'ninos',
    emojis: [
      ['👶', 'bebe niños'],
      ['🍼', 'biberon bebe'],
      ['🧸', 'juguetes peluche'],
      ['🎒', 'colegio mochila escuela'],
      ['🏫', 'colegio escuela guarderia'],
      ['✏️', 'material escolar'],
      ['📖', 'libros de texto'],
      ['👧', 'hija niña'],
      ['👦', 'hijo niño'],
      ['👨‍👩‍👧', 'familia'],
      ['🎈', 'cumpleaños fiesta'],
      ['🧷', 'pañales'],
      ['🛝', 'parque'],
      ['🎓', 'estudios universidad'],
      ['🩰', 'extraescolares baile'],
    ],
  },
  {
    id: 'mascotas',
    emojis: [
      ['🐶', 'perro mascota'],
      ['🐱', 'gato mascota'],
      ['🐾', 'mascotas'],
      ['🦴', 'pienso comida perro'],
      ['🐟', 'peces acuario'],
      ['🐦', 'pajaro'],
      ['🐰', 'conejo'],
      ['🐹', 'hamster'],
      ['🐴', 'caballo'],
      ['🦮', 'paseador perro'],
      ['🏥', 'veterinario'],
      ['🛁', 'peluqueria canina baño'],
      ['🐕', 'perro'],
      ['🐈', 'gato'],
      ['🦜', 'loro'],
    ],
  },
  {
    id: 'dinero',
    emojis: [
      ['💰', 'ahorro dinero'],
      ['🐷', 'hucha ahorro'],
      ['🏦', 'banco'],
      ['💶', 'euros efectivo'],
      ['💵', 'billetes efectivo'],
      ['🪙', 'monedas'],
      ['💳', 'tarjeta credito'],
      ['📈', 'inversion bolsa fondos'],
      ['📉', 'deuda perdidas'],
      ['🛟', 'colchon emergencia fondo'],
      ['🎯', 'objetivo meta'],
      ['💼', 'trabajo nomina sueldo'],
      ['🧾', 'impuestos hacienda renta'],
      ['🤝', 'prestamo deuda'],
      ['💸', 'gastos'],
      ['🏖️', 'jubilacion'],
      ['💎', 'patrimonio'],
      ['🎁', 'regalos'],
    ],
  },
  {
    id: 'facturas',
    emojis: [
      ['💡', 'luz electricidad'],
      ['🔥', 'gas calefaccion'],
      ['💧', 'agua'],
      ['📱', 'movil telefono'],
      ['🌐', 'internet fibra'],
      ['📡', 'television satelite'],
      ['🧾', 'facturas recibos'],
      ['📄', 'seguro poliza'],
      ['🛡️', 'seguro proteccion'],
      ['🏛️', 'impuestos ibi ayuntamiento'],
      ['🗑️', 'basura tasas'],
      ['📦', 'suscripciones'],
      ['🔁', 'cuotas recurrentes'],
      ['☁️', 'nube almacenamiento'],
      ['🎧', 'musica streaming suscripcion'],
    ],
  },
  {
    id: 'compras',
    emojis: [
      ['🛍️', 'compras tiendas'],
      ['👕', 'ropa camiseta'],
      ['👖', 'ropa pantalon'],
      ['👗', 'ropa vestido'],
      ['👟', 'zapatillas calzado'],
      ['👠', 'zapatos calzado'],
      ['👜', 'bolso complementos'],
      ['⌚', 'reloj'],
      ['💍', 'joyas'],
      ['💻', 'ordenador tecnologia'],
      ['🖥️', 'tecnologia'],
      ['🎧', 'auriculares tecnologia'],
      ['📦', 'paqueteria pedidos online'],
      ['🧴', 'perfumeria'],
      ['🕶️', 'gafas de sol'],
      ['🏬', 'centro comercial'],
    ],
  },
  {
    id: 'viajes',
    emojis: [
      ['✈️', 'avion vuelos viaje'],
      ['🏨', 'hotel alojamiento'],
      ['🧳', 'maleta viaje equipaje'],
      ['🏖️', 'playa vacaciones'],
      ['⛰️', 'montaña'],
      ['🏕️', 'camping'],
      ['🗺️', 'mapa excursion'],
      ['🚢', 'barco crucero'],
      ['🚐', 'furgoneta autocaravana'],
      ['🌍', 'mundo viajes'],
      ['🎡', 'parque de atracciones'],
      ['🏰', 'turismo'],
      ['⛷️', 'esqui nieve'],
      ['🛂', 'pasaporte visado'],
      ['🌴', 'vacaciones'],
    ],
  },
  {
    id: 'otros',
    emojis: [
      ['⭐', 'estrella favorito'],
      ['📌', 'varios'],
      ['❓', 'otros sin clasificar'],
      ['🎁', 'regalos'],
      ['💝', 'donaciones caridad'],
      ['⛪', 'iglesia'],
      ['📮', 'correos'],
      ['🖨️', 'oficina imprenta'],
      ['🧑‍💻', 'trabajo autonomo'],
      ['📝', 'gestoria tramites'],
      ['⚖️', 'abogado legal'],
      ['🔒', 'seguridad alarma'],
      ['🌱', 'sostenible'],
      ['🧧', 'propinas'],
      ['🎗️', 'ong'],
      ['✨', 'caprichos'],
    ],
  },
];

/** Minúsculas y sin tildes, para comparar palabras. */
export function normalizarPalabra(texto: string): string {
  return texto
    .toLocaleLowerCase('es')
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .trim();
}

/** Mapa palabra → emojis (en el orden de las secciones, sin repetir). */
export const PALABRAS_EMOJI: ReadonlyMap<string, readonly string[]> = (() => {
  const mapa = new Map<string, string[]>();
  for (const seccion of SECCIONES_EMOJI) {
    for (const [emoji, palabras] of seccion.emojis) {
      for (const palabra of palabras.split(/\s+/)) {
        const clave = normalizarPalabra(palabra);
        if (!clave) {
          continue;
        }
        const lista = mapa.get(clave) ?? [];
        if (!lista.includes(emoji)) {
          lista.push(emoji);
        }
        mapa.set(clave, lista);
      }
    }
  }
  return mapa;
})();
